import { render, staticRenderFns } from "./LoaderPage.vue?vue&type=template&id=37bd5b16&"
import script from "./LoaderPage.vue?vue&type=script&lang=ts&"
export * from "./LoaderPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports